"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.22.1
 */
'use client';

import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { Fragment as Fragment$1 } from 'react';
import clsx from 'clsx';
import { EditorTagBadgeIcon } from './index.mjs';
import { SvgIconType } from '../../../SvgIcon/svg-icon-type.mjs';
import { intersperse } from '../../../../helpers/intersperse.mjs';
import { css } from '../../../../styled-system/css/css.mjs';
import '../../../../styled-system/helpers.mjs';
import { sva } from '../../../../styled-system/css/sva.mjs';

const nestedBadgeValueRecipe = sva({
  className: "nested-badge-value",
  slots: ["root", "segment", "visible-segment", "truncated-segment", "chunk"],
  base: {
    root: {
      display: "flex",
      flexDir: "row",
      flexWrap: "nowrap",
      alignItems: "center",
      truncate: true,
      "& svg": {
        display: "inline-block",
        verticalAlign: "middle"
      }
    },
    segment: {
      fontSize: "token(sizes.3)",
      lineHeight: "token(sizes.4)"
    },
    "visible-segment": {
      flexShrink: "0",
      flexGrow: "0"
    },
    "truncated-segment": {
      display: "inline-block",
      truncate: true
    },
    chunk: {
      whiteSpace: "nowrap",
      fontSize: "token(sizes.3)",
      lineHeight: "token(sizes.4)",
      truncate: true
    }
  }
});
function NestedBadgeValue({ nameChunks, fullName }) {
  if (nameChunks.length === 0) {
    return /* @__PURE__ */ jsx(Fragment, { children: "Error: undefined" });
  }
  const styles = nestedBadgeValueRecipe();
  const nameElements = nameChunks.map((chunk, idx) => /* @__PURE__ */ jsx("span", { className: styles.chunk, children: chunk }, idx + chunk));
  if (nameElements.length === 1) {
    return /* @__PURE__ */ jsx("span", { className: styles.root, children: nameElements[0] });
  }
  if (nameElements.length <= 2) {
    return /* @__PURE__ */ jsx("span", { className: styles.root, children: intersperse(nameElements, /* @__PURE__ */ jsx(ValueNestingIcon, {})).map((segment, i) => /* @__PURE__ */ jsx(Fragment$1, { children: segment }, i)) });
  }
  const { 0: first, [nameChunks.length - 1]: last, ...rest } = nameElements;
  const middle = Object.values(rest);
  return /* @__PURE__ */ jsxs("span", { className: styles.root, title: fullName, children: [
    /* @__PURE__ */ jsx("span", { className: clsx(styles.segment, styles["visible-segment"]), children: first }),
    /* @__PURE__ */ jsx("span", { className: clsx(styles.segment, styles["truncated-segment"]), children: middle.map((segment, idx) => [/* @__PURE__ */ jsx(ValueNestingIcon, {}, idx), segment]).flat().map((segment, i) => /* @__PURE__ */ jsx(Fragment$1, { children: segment }, i)) }),
    /* @__PURE__ */ jsxs("span", { className: clsx(styles.segment, styles["visible-segment"]), children: [
      /* @__PURE__ */ jsx(ValueNestingIcon, {}),
      last
    ] })
  ] });
}
function ValueNestingIcon() {
  return /* @__PURE__ */ jsx(
    EditorTagBadgeIcon,
    {
      type: SvgIconType.ChevronRight,
      className: css({
        mb: "0.5"
      })
    }
  );
}

export { NestedBadgeValue, ValueNestingIcon, nestedBadgeValueRecipe };
